export interface DownloadTmFileRequest {
    guid?: string;
    projectId: number;
    companyId: number;
    type: string;
    entityId?: number;
    stepNum?: number;
    temp?: boolean;
    fileLink?: string;
}

export enum DownloadTmFileType {
    AS_ATTACHMENT,
    STEPS,
    USERS,
    TEST_RAWDATA,
    TESTS_REF_TEMPLATE,
    RISK_ANALYSIS,
    TM_CHANGE,
    REQUIREMENT_TO_TEST,
    REQUIREMENT_TO_TRANSPORT,
    AS_LONG_REQUEST_ATTACHMENT
}
